/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as commonV1 from "./deviceapis_device_common_v1.pb"

/**
 * Сервис управления настройками Concierge
 */

/**
 * Сервис управления настройками Concierge
 */
export class ConciergeSettingsServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод редактирования настроек Concierge
   */
  EditConciergeSettings = (req: Pick<EditConciergeSettingsRequestDto, "updateMask"> & { data: ConciergeSettingsRequestDto & fm.RequireAtLeastOne<ConciergeSettingsRequestDto> }, init?: RequestInit): Promise<EditConciergeSettingsResponseDto> => {
    return fm.request<Pick<EditConciergeSettingsRequestDto, "updateMask"> & { data: ConciergeSettingsRequestDto & fm.RequireAtLeastOne<ConciergeSettingsRequestDto> }, EditConciergeSettingsResponseDto>(`${this.host}/device/api/v1/concierge/settings`, { ...init, method: "PATCH", body: JSON.stringify(req.data, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения настроек Concierge
   */
  GetConciergeSettings = (req?: GetConciergeSettingsRequestDto, init?: RequestInit): Promise<GetConciergeSettingsResponseDto> => {
    return fm.request<GetConciergeSettingsRequestDto, GetConciergeSettingsResponseDto>(`${this.host}/device/api/v1/concierge/settings${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Настройки Concierge
 */
export type ConciergeSettingsRequestDto = {
  /**
   * Флаг включения Concierge вызова
   */
  isConciergeOn: boolean
  /**
   * Параметр SIP Invite для Concierge вызова.
   * Произвольная строка которая передается в SIP сервер.
   * Диапазон: 1..128
   */
  sipInvite: string
  /**
   * Параметр SIP Server для Concierge вызова.
   * При пустом sip_server будет использован сервер SIP регистрации
   */
  sipServer?: string
}
/**
 * Настройки Concierge
 */
export type ConciergeSettingsResponseDto = {
  /**
   * Флаг включения Concierge вызова
   */
  isConciergeOn: boolean
  /**
   * Параметр SIP Invite для Concierge вызова.
   * Произвольная строка которая передается в SIP сервер.
   * Диапазон: 1..128
   */
  sipInvite: string
  /**
   * Параметр SIP Server для Concierge вызова.
   * При пустом sip_server будет использован сервер SIP регистрации
   */
  sipServer: string
}
/**
 * Запрос редактирования настроек Concierge
 */
export type EditConciergeSettingsRequestDto = {
  /**
   * Настройки Concierge
   */
  data: ConciergeSettingsRequestDto
  /**
   * Маска полей обновления
   */
  updateMask?: string | null
}
/**
 * Ответ на запрос редактирования настроек Concierge
 */
export type EditConciergeSettingsResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Настройки Concierge
   */
  readonly data: ConciergeSettingsResponseDto
  /**
   * Ошибка
   */
  readonly error: EditConciergeSettingsResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type EditConciergeSettingsResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type EditConciergeSettingsResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения настроек Concierge
 */
export type GetConciergeSettingsRequestDto = {
}
/**
 * Ответ на запрос получения настроек Concierge
 */
export type GetConciergeSettingsResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Настройки Concierge
   */
  readonly data: ConciergeSettingsResponseDto
}>
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Настройки Concierge
   */
  "ConciergeSettings": {
    "kind": "class",
    "text": "Настройки Concierge",
    "fields": {
      /**
       * Флаг включения Concierge вызова
       */
      "isConciergeOn": {
        "type": "bool",
        "text": "Флаг включения Concierge вызова",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Параметр SIP Invite для Concierge вызова.
       * Произвольная строка которая передается в SIP сервер.
       * Диапазон: 1..128
       */
      "sipInvite": {
        "type": "string",
        "text": "Параметр SIP Invite для Concierge вызова.\nПроизвольная строка которая передается в SIP сервер.\nДиапазон: 1..128",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Параметр SIP Server для Concierge вызова.
       * При пустом sip_server будет использован сервер SIP регистрации
       */
      "sipServer": {
        "type": "string",
        "text": "Параметр SIP Server для Concierge вызова.\nПри пустом sip_server будет использован сервер SIP регистрации",
      },
    },
  },
  /**
   * Запрос редактирования настроек Concierge
   */
  "EditConciergeSettingsRequest": {
    "kind": "class",
    "text": "Запрос редактирования настроек Concierge",
    "fields": {
      /**
       * Настройки Concierge
       */
      "data": {
        "type": "ConciergeSettings",
        "text": "Настройки Concierge",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Маска полей обновления
       */
      "updateMask": {
        "type": "google.protobuf.FieldMask",
        "text": "Маска полей обновления",
      },
    },
  },
  /**
   * Ответ на запрос редактирования настроек Concierge
   */
  "EditConciergeSettingsResponse": {
    "kind": "class",
    "text": "Ответ на запрос редактирования настроек Concierge",
    "fields": {
      /**
       * Настройки Concierge
       */
      "data": {
        "type": "ConciergeSettings",
        "text": "Настройки Concierge",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "EditConciergeSettingsResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "EditConciergeSettingsResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения настроек Concierge
   */
  "GetConciergeSettingsRequest": {
    "kind": "class",
    "text": "Запрос получения настроек Concierge",
  },
  /**
   * Ответ на запрос получения настроек Concierge
   */
  "GetConciergeSettingsResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения настроек Concierge",
    "fields": {
      /**
       * Настройки Concierge
       */
      "data": {
        "type": "ConciergeSettings",
        "text": "Настройки Concierge",
      },
    },
  },
}